import React from 'react';
import PropTypes from 'prop-types';
import { css, StyleSheet } from 'aphrodite';
import { childrenPropType, TSS_RED, TSS_BLUE, TSS_GREEN, TSS_ORANGE, TSS_ORANGE_2 } from 'tss-core-lib-common';
import Icon from 'react-svg-ikon';

import { IMG_ICON_WARNING_O_LARGE, IMG_ICON_ERROR_TRIANGLE, IMG_ICON_SUCCESS_O_LARGE } from '../img';

var styles = void 0;

var FormInfo = function FormInfo(_ref) {
  var children = _ref.children,
      warning = _ref.warning,
      fatal = _ref.fatal,
      success = _ref.success;

  var color = TSS_BLUE();
  var icon = IMG_ICON_WARNING_O_LARGE;

  if (warning) {
    color = TSS_ORANGE();
  } else if (fatal) {
    color = TSS_RED();
    icon = IMG_ICON_ERROR_TRIANGLE;
  } else if (success) {
    color = TSS_GREEN();
    icon = IMG_ICON_SUCCESS_O_LARGE;
  }
  return React.createElement(
    'div',
    { className: css(styles.container, fatal && styles.fatal, warning && styles.warning, success && styles.success) },
    React.createElement(Icon, { src: icon, stroke: color, className: css(styles.icon) }),
    React.createElement(
      'p',
      { className: css(styles.content) },
      children
    )
  );
};

FormInfo.propTypes = {
  children: childrenPropType.isRequired,
  fatal: PropTypes.bool,
  warning: PropTypes.bool,
  success: PropTypes.bool
};

FormInfo.defaultProps = {
  fatal: false,
  warning: false,
  success: false
};

styles = StyleSheet.create({
  container: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: TSS_BLUE(0.2),
    borderLeft: '4px solid ' + TSS_BLUE(),
    padding: '1.9rem',
    fontSize: '1.6rem'
  },

  fatal: {
    backgroundColor: TSS_RED(0.3),
    borderLeft: '4px solid ' + TSS_RED()
  },

  warning: {
    backgroundColor: TSS_ORANGE_2(),
    borderLeft: '4px solid ' + TSS_ORANGE()
  },

  success: {
    backgroundColor: TSS_GREEN(0.3),
    borderLeft: '4px solid ' + TSS_GREEN()
  },

  content: {
    flex: '1 1 100%',
    margin: '0 0 0 2rem'
  }
});

export default FormInfo;